module.exports = __webpack_public_path__ + "img/look-coupon.cb312736.png";